import Translations from "@/lang/translations.js";

function toGetterName(key) {
    if (key.startsWith("get")) {
        return key;
    }

    return "get" + key.charAt(0).toUpperCase() + key.slice(1);
}

function getFallbackKey(key) {
    return key.startsWith("get")
        ? key.slice(3)
        : key;
}

function t(key, language, ...args) {
    const getterName = toGetterName(key);
    const getter = Translations[getterName];

    if ("function" === typeof getter) {
        return getter(language, ...args);
    }

    return getFallbackKey(key);
}

export default {
    t: t
};
